interface ScrollToElementIfNeededParams {
  containerEl: HTMLElement | null;
  intersectionObserverOptions?: IntersectionObserverInit;
  itemSelector: string;
  scrollIntoViewOptions?: ScrollIntoViewOptions;
}

export const scrollToElementIfNeeded = ({
  containerEl,
  itemSelector,
  scrollIntoViewOptions = {},
  intersectionObserverOptions = {},
}: ScrollToElementIfNeededParams): void => {
  if (!containerEl) return;

  const options: IntersectionObserverInit = {
    root: containerEl,
    rootMargin: "0px",
    threshold: 1.0,
    ...intersectionObserverOptions,
  };

  const element = containerEl.querySelector<HTMLElement>(itemSelector);
  if (!element) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.unobserve(element);
        return;
      }
      element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        ...scrollIntoViewOptions,
      });
      observer.unobserve(element);
    });
  }, options);

  observer.observe(element);
};
